import React, { useState, useEffect } from 'react';
import SearchForCustomer from '../components/Customer/SearchForCustomer';
import CustomerService from '../services/WebCustomerService';
import InfiniteScrollTable from '../components/shared/InfiniteScrollTable';
import 'react-tippy/dist/tippy.css'
import {
  TableHead,
  TableCell,
  TableRow
} from '@material-ui/core';
import currencyFormatter from 'common/currencyFormatter';
import ThemedTableRow from '../components/shared/ThemedTableRow';
import { Tooltip } from 'react-tippy';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import ProfileService from '../services/WebProfileService'

const ENTER_KEY = 13;
const styles = {
  balance: {
    textAlign: 'right'
  },
  searchWrapper : {
    display : "flex"
  }
}

function CustomerSearchPage(props) {
  const [customers, setCustomers] = useState([]);
  const [skip, setSkip] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const [showDisabled, setShowDisabled] = useState(false);
  const [isAdmin, setIsAdmin] = useState(null);

  function rowClicked(rowIndex, cell) {
    let customerId = customers[rowIndex].id
    props.history.push({ pathname:`/customer/${customerId}/edit`});    
  }

  function rowSelected(rowIndex, which) {
    if (which === ENTER_KEY) {
      rowClicked(rowIndex);
    }
  }
  function  genTableHeader() {
    return (
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Street</TableCell>
          <TableCell>City</TableCell>
          <TableCell>State</TableCell>
          <TableCell>Phone</TableCell>
          <TableCell>Email</TableCell>
          <TableCell>Customer Balance</TableCell>          
        </TableRow>
      </TableHead>
    )
  }

  function rows() {
    const rows = customers.map((customer, index) => {
      return (
        <ThemedTableRow onKeyDown={e => rowSelected(index, e.which)} onClick={e => rowClicked(index)} tabIndex={0} className='customer-row' key={`row-${customer.id}`}>
          <TableCell className='customer-name'>
            <Tooltip trigger="mouseenter"
              theme='light'
              size='small'
              useContext html={(<p>{customer.name}</p>)}>{customer.name}
            </Tooltip>
          </TableCell>
          <TableCell className='customer-street'>
            <Tooltip trigger="mouseenter"
              size='small'
              theme='light'
              useContext html={(<p>{customer.street}</p>)}>{customer.street}
            </Tooltip>
          </TableCell>
          <TableCell className='customer-city'>
            <Tooltip trigger="mouseenter"
              size='small'
              theme='light'
              useContext html={(<p>{customer.city}</p>)}>{customer.city}
            </Tooltip>
          </TableCell>
          <TableCell className='customer-state'>
            {customer.state}
          </TableCell>
          <TableCell className='customer-phone'>
            <Tooltip trigger="mouseenter"
              size='small'
              theme='light'
              useContext html={(<p>{customer.phone}</p>)}>{customer.phone}
            </Tooltip>
          </TableCell>
          <TableCell className='customer-email'>
            <Tooltip trigger="mouseenter"
              size='small'
              theme='light'
              useContext html={(<p>{customer.email}</p>)}>{customer.emails}
            </Tooltip>
          </TableCell>
          <TableCell style={styles.balance}>
            <Tooltip trigger="mouseenter"
              size='small'
              theme='light'
              useContext html={(<p>{currencyFormatter.formatUSD(customer.balance)}</p>)}>{currencyFormatter.formatUSD(customer.balance)}
            </Tooltip>
          </TableCell>          
        </ThemedTableRow>
      )
    });
    return rows;
  }
  
  function getRowsFromServer(take) {
    setHasMore(false);
    
    // What is the difference between using a promise or not using a promise here
    CustomerService.customerSearch(searchValue, take, skip, showDisabled, (newCustomers) => {
      setSkip(skip + take);
      setCustomers([...customers, ...newCustomers]);
      setHasMore(take === newCustomers.length);
    });
  }

  useEffect(() => {
      ProfileService.getProfile( (results) => {
        setIsAdmin(results.admin);
      });
  },[]);

  useEffect( () => {
    setCustomers([]);
    setSkip(0);
    setHasMore(true);
  }, [searchValue,showDisabled]);

  return (
    <div>
      <div style={styles.searchWrapper}>
        <SearchForCustomer valueReturned={setSearchValue} />
        {isAdmin ? <FormControlLabel
                    id="showDisabled"
                    label="Show Disabled"
                    control={<Checkbox
                                checked={showDisabled}
                                onChange={ event => setShowDisabled(event.target.checked) } 
                            />}
                      /> : null}
      </div>
        <InfiniteScrollTable
          className='customer-search-results' 
          genTableHeader={genTableHeader}
          rowRender={rows} 
          hasMore={hasMore}
          getRowsFromServer={getRowsFromServer}/>
    </div>
  )

}

export default CustomerSearchPage;
